export class Quiz {

    private _questions: Question[] = [];
    private _current: Question = null;
    private _progress: HTMLDivElement;
    private _progressBar: HTMLDivElement;
    private _countCorrect: number = 0;

    constructor(public element: HTMLDivElement) {
        element.querySelectorAll<HTMLDivElement>(".quiz-question").forEach((e) => {
            var question = new Question(e);
            this._questions.push(question);
            question.onAnswered.add((question, correct) => this.handleAnswer(question, correct));
            question.onNext.add(() => this.handleNext(question));
        });

        this._progress = this.element.querySelector(".quiz-progress");
        this._progressBar = this.element.querySelector(".quiz-progress-bar");

        if (this._questions.length > 0) {
            this._current = this._questions[0];
        }

        this.element.querySelector(".quiz-result-reset").addEventListener("click", () => this.reset());
    }

    private reset(): void {
        this.element.querySelector(".quiz-result-particles").innerHTML = "";
        this._countCorrect = 0;
        this._progress.classList.remove("e5-hidden");
        this._progressBar.style.width = 0 + "%";
        if (this._questions.length > 0) {
            this._current = this._questions[0];
            this._current.element.classList.remove("e5-hidden");
        }
        this.element.querySelector(".quiz-result").classList.add("e5-hidden");
        $(".answer", this.element).removeClass("active");
        $(".answer", this.element).prop("disabled", false);

        for (var question of this._questions) {
            question.element.classList.remove("answered", "correct", "wrong");
        }

        if(this._current){
            $(".answer:first-child", this._current.element).focus();
        }
    }

    private handleAnswer(question: Question, correct: boolean): void {
        this.updateProgressBar();
        if (correct) {
            this._countCorrect++;
        }

        this.scrollTop($(".explanation", question.element));
    }

    private scrollTop(element: JQuery, offset: number = 0, force: boolean = false): void {
        if (!this.element.hasAttribute("data-autoscroll")) {
            return;
        }
        var off = element.offset();
        if (force || document.documentElement.scrollTop < off.top) {
            // var dist = Math.abs(off.top - document.documentElement.scrollTop);
            // gs.TweenMax.to(document.documentElement, dist / 300, { scrollTop: off.top });
            gs.TweenMax.to(document.documentElement, 1, { scrollTop: off.top + offset });
        }
    }

    private handleNext(question: Question): void {
        var scrollTop = $(window).scrollTop();

        this._current.element.classList.add("e5-hidden");
        var index = this._questions.indexOf(this._current);
        index++;

        if (this._questions.length > index) {
            this._current = this._questions[index];
            this._current.element.classList.remove("e5-hidden");
        } else {
            this._progress.classList.add("e5-hidden");

            var countWrong = this._questions.length - this._countCorrect;

            var state: "all-wrong" | "all-correct" | "more-wrong" | "more-correct" | "none" = "none";
            if (this._countCorrect == this._questions.length) {
                state = "all-correct";
            } else if (this._countCorrect == 0) {
                state = "all-wrong";
            } else if (this._countCorrect > countWrong) {
                state = "more-correct";
            } else {
                state = "more-wrong";
            }

            $(".quiz-result-text", this.element).addClass("e5-hidden");
            $(".quiz-result-text." + state, this.element).removeClass("e5-hidden");

            var particles = "";
            for (var i = 0; i < 40; ++i) {
                if (state == "all-correct") {
                    // particles += `<div class="particle e5 flow icon-789"></div>`;
                    var k = i % 16;
                    var x = k % 4;
                    var y = Math.floor(k / 4);
                    var xPos = x * 100;
                    var yPos = y * 100;
                    particles += `<div class="particle e5 sprite-sheet" style="background-position: -${xPos}px -${yPos}px;"></div>`;
                } else if (state == "all-wrong") {
                    particles += `<div class="particle e5 flow icon-436"></div>`;
                } else if (state == "more-wrong") {
                    particles += `<div class="particle e5 flow icon-784"></div>`;
                } else if (state == "more-correct") {
                    particles += `<div class="particle e5 flow icon-785"></div>`;
                }
            }
            this.element.querySelector(".quiz-result-particles").innerHTML = particles;

            this.element.querySelector(".quiz-result-count").innerHTML =
                this.getStyleText(this._countCorrect + " ", 48) + " "
                + this.getStyleText(" " + this.element.getAttribute("data-resultlabelseparator") + " ", 24) + " " + this.getStyleText(this._questions.length + "", 92);

            this.element.querySelector(".quiz-result").classList.remove("e5-hidden");

            this.element.querySelector<HTMLButtonElement>(".quiz-result-reset").focus();
        }

        $(window).scrollTop(scrollTop);

        this.scrollTop($(this.element), -20);

        if(this._current){
            $(".answer:first-child", this._current.element).focus();
        }
    }

    private getStyleText(text: string, fontSize: number, cssClass: string = ""): string {
        var html = "";
        html += `<span class="styled-text ${cssClass}" style="font-size: ${fontSize}px;">`;
        for (var letter of text) {
            if (letter == "") {
                html += '<span class="space"> </span>';
            } else {
                html += `<span class="letter">`;
                html += `<span class="placeholder">${letter}</span>`;
                html += `<span class="inner a">${letter}</span>`;
                html += `<span class="inner b">${letter}</span>`;
                html += `<span class="inner c">${letter}</span>`;
                html += `<span class="inner d">${letter}</span>`;
                html += `</span>`;
            }
        }
        html += '</span>';
        return html;
    }

    private updateProgressBar(): void {
        var index = this._questions.indexOf(this._current) + 1;
        this._progressBar.style.width = ((index / (this._questions.length)) * 100).toFixed(4) + "%";
        this._progressBar.parentElement.classList.add("active");
    }
}

class Question {

    public onAnswered = e5.Signal.create<[Question, boolean]>();
    public onNext = e5.Signal.create<[Question]>();

    constructor(public element: HTMLDivElement) {
        $(element).on("click", ".answer", (e) => {
            var scrollTop = $(window).scrollTop();
            var correct = e.currentTarget.classList.contains("correct");
            e.currentTarget.classList.add("active");
            this.element.classList.add("answered",
                correct ? "correct" : "wrong");
            this.onAnswered.dispatch(this, correct);
            $(window).scrollTop(scrollTop);
            $(".answer", element).prop("disabled", true);
            $(".quiz-control-next", element).focus();
        });

        $(element).on("click", ".quiz-control-next", (e) => {
            this.onNext.dispatch(this);
        });
    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        document.querySelectorAll<HTMLDivElement>(".quiz").forEach((element) => {
            new Quiz(element);
        });
    }
);